export default "__VITE_ASSET__19a06710__"